export function getFlagState(envVar: string): boolean {
  // TODO: Can implement query string support as well
  return import.meta.env[envVar] === 'true' || false;
}

export const featureFlags = {
  agGrid: getFlagState('VITE_APP_ENABLE_REVIEW_GRID'),
  dataPoolRouterConfigSettings: getFlagState('VITE_APP_ENABLE_DATAPOOL_ROUTER_CONFIG_SETTINGS'),
  dataValidation: getFlagState('VITE_APP_ENABLE_DATA_VALIDATION'),
  documentMenuItem: getFlagState('VITE_APP_ENABLE_DOCUMENT_MENU_ITEM'),
  documentManfiestExportLinks: getFlagState('VITE_APP_ENABLE_DOCUMENT_MANIFEST_EXPORT_LINKS'),
  includeParentFilesInDelivery: getFlagState('VITE_APP_ENABLE_INCLUDE_PARENT_FILES_IN_DELIVERY'),
  modifyFieldOrderFromEBTags: getFlagState('VITE_APP_MODIFY_FIELD_ORDER_FROM_EB_TAGS'),
  reviewEditFieldProperties: getFlagState('VITE_APP_REVIEW_EDIT_FIELD_PROPERTIES'),
  duplicateFields: getFlagState('VITE_APP_DUPLICATE_FIELDS'),
  allowPrefetchingInReview: getFlagState('VITE_APP_ALLOW_PREFETCHING_IN_REVIEW'),
  showPackagerMenuItem: getFlagState('VITE_APP_SHOW_PACKAGER_MENU_ITEM'),
  MATMenuItem: getFlagState('VITE_APP_SHOW_MAT_MENU_ITEM'),
  rulesets: getFlagState('VITE_APP_ENABLE_RULESETS'),
};
